<template>
  <validation-observer
    #default="{ handleSubmit }"
    ref="refFormObserver"
  >
    <!-- Form -->
    <b-form
      class=""
      @submit.prevent="handleSubmit(onSubmit)"
      @reset.prevent="resetForm"
    >
      <!-- Name -->
      <validation-provider
        #default="validationContext"
        name="Tên thư mục"
        rules="required|max:150"
      >
        <b-form-group label-for="name">
          <template #label>
            <label class="d-block font-weight-bolder">Tên thư mục <span class="text-danger">*</span></label>
          </template>
          <b-form-input
            id="name"
            v-model="itemData.name"
            :state="getValidationState(validationContext)"
          />

          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-2"
          type="submit"
          :disabled="loading"
        >
          {{ $t('Save') }}
        </b-button>
      </div>

    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
} from 'bootstrap-vue'
import {
  computed,
  ref,
} from '@vue/composition-api'
import store from '@/store'
import { showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNumDot, max,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    existData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
    }
  },
  computed: {
    // loading() {
    //   return this.$store.state.files.loading;
    // },
    // selectedCategory() {
    //   return this.$store.state.files.selected_category
    // },
  },

  setup(props, context) {
    const id = ref(props.existData ? props.existData.id : 0);
    const loading = computed({
      get() {
        return store.state.files.loading
      },
      set(val) {
        // console.log('loading val', val);
      },
    })
    const selectedCategory = computed(() => store.state.files.selected_category)
    const errorMessage = ref('')
    const defaultItemData = {
      name: '',
      parent_id: 0,
    }
    const itemData = ref(props.existData || JSON.parse(JSON.stringify(defaultItemData)))
    // console.log('itemData', itemData);
    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      errorMessage.value = '';
      loading.value = true;
      if (!selectedCategory.value.id) {
        return showToast('Chưa chọn thư mục', { variant: 'danger' });
      }
      store.dispatch('files/setState', { loading: true });
      store.dispatch('files/createCategory', { name: itemData.value.name, parent_id: selectedCategory.value.id, type: selectedCategory.value.type })
        .then((response) => {
          loading.value = false
          if (response.status === 200) {
            if (response.data.code === 200) {
              store.dispatch('files/setState', { created_category: response.data.data });
              itemData.value.name = '';
              showToast(response.data.message, { variant: 'success' });
            } else {
              showToast(response.data.message)
            }
          }
          store.dispatch('files/setState', { loading: false });
          context.emit('closeCatFormModal')
        })
    }
    return {
      id,
      errorMessage,
      loading,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
    }
  },

}
</script>

<style></style>
